module.exports = __webpack_public_path__ + "static/media/hero-img.8b0d2025.png";